import {
  Component,
  AfterViewInit,
  ViewChild,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { LicenseANPR } from '@classes/anpr/licenseANPR';
import {
  faQuestion,
  faCheck,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { MatSort } from '@angular/material/sort';
import { CallANPR } from '@classes/anpr/callANPR';
import {
  FormControl,
  FormGroupDirective,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Output, EventEmitter } from '@angular/core';
import { ClientSmartHub } from '@classes/client/client';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnChanges {
  @Input() calls: CallANPR[];
  faQuestion = faQuestion;
  faCheck = faCheck;
  faCross = faTimes;
  @Output() selectedCallEvent = new EventEmitter<CallANPR>();
  selectedCall: CallANPR;
  isLoading: boolean;
  @Input() answer: CallANPR;

  // idée : fair eun input <<dontChange>>, mis à false de base, mis à true après avoir répondu à la question. Ici dans le ngChange, on regarde si c'est true, on recharge pas le tableau et on fait ce qu'il faut, et on le remet à false. Sinon, on fait le rehcargement comme d'hab !

  historyFormGroup: UntypedFormGroup;

  displayedColumns: string[] = [
    'selection',
    'date',
    'hour',
    'userName',
    'numberPlate',
    'userAnswer',
  ];

  dataSource: MatTableDataSource<CallANPR>;

  constructor(private formBuilder: UntypedFormBuilder) {}

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit(): void {
    this.isLoading = true;
    this.answer = null;
    this.initForm();
  }

  modififyAnswer() {
    for (let i = 0; i < this.calls.length; i++) {
      if (this.calls[i].id == this.answer.id) {
        this.calls[i].userAnswer = this.answer.userAnswer;
      }
    }
  }

  emitCall() {
    this.selectedCallEvent.emit(this.selectedCall);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.calls) {
      this.selectedCall = null;
      this.isLoading = true;
      this.initTable();
    }
    if (changes.answer && this.answer != null) {
      this.modififyAnswer();
      this.answer = null;
    }
  }

  initTable() {
    if (
      typeof this.calls !== 'undefined' &&
      typeof this.selectedCall !== 'undefined'
    ) {
      // prevent ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        if (!this.selectedCall) {
          this.selectedCall = this.calls[0];
        }
        this.updateTable();
      });
    }
  }

  updateTable() {
    this.dataSource = new MatTableDataSource<CallANPR>(this.calls);
    this.dataSource.paginator = this.paginator;

    this.isLoading = false;
    this.emitCall();
  }

  initForm() {
    this.historyFormGroup = this.formBuilder.group({
      call: [this.selectedCall],
    });
    this.historyFormGroup.controls['call'].valueChanges.subscribe((value) => {
      this.selectedCall = value;
      this.emitCall();
    });
  }
}
